<template>
  <div>
    <div
        class="people-filters"
        v-if="type === 'brokers'"
    >
      <div class="industries" style="border:0;padding:0;">
        <h3>
          Locations
        </h3>

        <div class="options">
          <span
              v-for="location in locations"
              :key="location"
              :class="locationFilter === location ? 'active' : ''"
              @click="locationFilter = location"
          >
            {{ location }}
          </span>
        </div>

        <br>

        <h3>
          Industry
        </h3>

        <div class="options">
          <span
              v-for="industry in industries"
              :key="industry.label"
              :class="industryFilter === industry.key ? 'active' : ''"
              @click="industryFilter = industry.key"
          >
            {{ industry.label }}
          </span>
        </div>
      </div>
    </div>

    <div class="white-padding">
      <div class="people-list">
        <div
            v-for="person in people"
            :key="person.name + person.title"
            class="person-card"
            v-if="!filterOut(person)"
        >
          <a :href="person.url">
            <div
                class="img"
                :style="photoStyle(person.photo)"
            ></div>
            <div class="content">
              <h2>
                {{ person.name }}
              </h2>
              <p>
                {{ person.title }}<br>
                {{ person.location }}
              </p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'type'
  ],

  data() {
    return {
      people: JSON.parse(document.getElementById('peopleJson').innerHTML),
      locationFilter: 'All Locations',
      industryFilter: null,
      locations: [
        'All Locations',
        'Oklahoma City',
        'Tulsa'
      ],
      industries: [
        {
          label: 'All Industries',
          key: null
        },

        {
          label: 'Capital Markets',
          key: 'investment'
        },

        {
          label: 'Industrial',
          key: 'industrial'
        },

        {
          label: 'Office',
          key: 'office'
        },

        {
          label: 'Retail',
          key: 'retail'
        },

        {
          label: 'Multifamily',
          key: 'multifamily'
        }
      ],
      capType:
          this.type.charAt(0).toUpperCase() +
          this.type.slice(1)
    };
  },

  mounted() {
    let peopleJson = document.getElementById('peopleJson');

    if (peopleJson) {
      peopleJson.parentElement.removeChild(peopleJson);
    }
  },

  methods: {
    filterOut(person) {
      if (this.locationFilter !== 'All Locations') {
        if (person.location !== this.locationFilter) {
          return true;
        }
      }

      if (this.industryFilter) {
        if (person.industry !== this.industryFilter) {
          return true;
        }
      }

      return false;
    },

    photoStyle(photo) {
      return `background-image:url('${photo}')`;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/admin/people/view.vue